/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_Pain_HintInputs */

const en_us2_profile_page_pain_hint = /** @type {(inputs: Profile_Page_Pain_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pain, injuries and the health questionnaire`)
};

const pt_br2_profile_page_pain_hint = /** @type {(inputs: Profile_Page_Pain_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores, lesões e o questionário de saúde`)
};

const es_419_profile_page_pain_hint = /** @type {(inputs: Profile_Page_Pain_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolores, lesiones y el cuestionario de salud`)
};

const pt_pt2_profile_page_pain_hint = /** @type {(inputs: Profile_Page_Pain_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores, lesões e o questionário de saúde`)
};

const fr_fr2_profile_page_pain_hint = /** @type {(inputs: Profile_Page_Pain_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleurs, blessures et questionnaire de santé`)
};

const de_de2_profile_page_pain_hint = /** @type {(inputs: Profile_Page_Pain_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerzen, Verletzungen und der Gesundheitsfragebogen`)
};

const it_it2_profile_page_pain_hint = /** @type {(inputs: Profile_Page_Pain_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolori, infortuni e il questionario sulla salute`)
};

/**
* | output |
* | --- |
* | "Pain, injuries and the health questionnaire" |
*
* @param {Profile_Page_Pain_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_pain_hint = /** @type {((inputs?: Profile_Page_Pain_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_Pain_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_pain_hint(inputs)
	if (locale === "es-419") return es_419_profile_page_pain_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_pain_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_pain_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_page_pain_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_page_pain_hint(inputs)
	return en_us2_profile_page_pain_hint(inputs)
});
export { profile_page_pain_hint as "profile.page_pain_hint" }